module.exports = __webpack_public_path__ + "img/Poorter_hotel-333.825b3b8c.jpg";